export enum UserPermission {
  CREATE = "Create",
  SUPPORT = "Support",
  VIEW = "View",
  APPROVE = "Approve",
}

export enum PermissionValue {
  TRUE = "True",
  FALSE = "False",
}
